import {Component, OnInit} from '@angular/core';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';
import {CostChartInfo} from '../../../../models/cost-chart-info.interface';
import {Master} from '../../../../../admin/models/master.interface';

@Component({
  selector: 'app-additional-chart',
  templateUrl: './additional-chart.component.html',
  styleUrls: ['./additional-chart.component.scss']
})
export class AdditionalChartComponent implements OnInit {

  text = 'Payments to Collection points';
  subtitle!: string;
  order!: string | undefined;
  data!: CostChartInfo;
  datasets!: number;
  years!: number[];
  categories!: Master[];

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);
      if (search.type == null) {
        search.type = "RETAIL";
      }
      this.kfChartsService.getCostAdditionalCategories().subscribe(data => this.categories = data);

      this.kfChartsService.getYears('cost', 'WEEE_SYSTEM_SCHEMA')
        .subscribe(data => {
          this.years = data;

          this.kfChartsService.countCostAdditionalDatasets(search)
            .subscribe(datasets => {
              this.datasets = datasets;
              if (datasets > 3) {
                this.kfChartsService.getCostAdditional(search)
                  .subscribe(response => {
                    this.data = response;
                    this.subtitle = this.getSubtitle(search);
                  });
              } else {
                this.subtitle = 'To keep confidentiality, only charts with more than 3 data sets can be displayed, apologies for the inconvenience';
              }
            });
          if (!search.startYear) {
            search.startYear = data[0];
          }
        });
    });
  }

  private getSubtitle(search: ChartsSearchInterface): string {
    const subtitle = search.type === 'MUNICIPAL' ? 'Municipal collection '
      : search.type === 'OTHER' ? 'Other collection ' : 'Retail collection ';
    return subtitle + 'points ' + search.startYear + ' (%)';
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});
  }

}
